const initial_state = {
    by_device_id: {},
};
const per_device_initial = {};
const per_device_reducer = (state = per_device_initial, action) => {
    switch (action.type) {
        case 'SET_Z3K_ANALOG_OUTPUT_VALUE':
            return {
                ...state,
                [action.object_id]: {
                    value: action.value,
                    request_time: action.request_time,
                },
            };
        case 'SEND_Z3K_CUSTOM_COMMAND__SUCCESS':
            if (state[action.object_id]?.request_time > action.request_time)
                return state;
            else {
                const { [action.object_id]: _, ...rest } = state;
                return rest;
            }
        case 'SEND_Z3K_CUSTOM_COMMAND__FAIL': {
            const { [action.object_id]: _, ...rest } = state;
            return rest;
        }
        default:
            return state;
    }
};
export const z3k_analog_output_value_reducer = (state = initial_state, action) => {
    switch (action.type) {
        case 'SET_Z3K_ANALOG_OUTPUT_VALUE':
        case 'SEND_Z3K_CUSTOM_COMMAND__SUCCESS':
        case 'SEND_Z3K_CUSTOM_COMMAND__FAIL':
            return {
                by_device_id: {
                    ...state.by_device_id,
                    [action.device_id]: per_device_reducer(state.by_device_id[action.device_id], action),
                },
            };
        default:
            return state;
    }
};
